import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=46f5380e&scoped=true"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"
import style0 from "./Posts.vue?vue&type=style&index=0&id=46f5380e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f5380e",
  null
  
)

export default component.exports